import { useStaticQuery, graphql } from "gatsby"

export const useBlogCategories = () => {
  const { allPrismicBlogCategory } = useStaticQuery(graphql`
    query {
      allPrismicBlogCategory(
        sort: {first_publication_date: ASC}
      ) {
        nodes {
          url
          data {
            title {
              text
            }
          }
          posts {
            id
          }
        }
      }
    }
  `)
  return allPrismicBlogCategory.nodes || []
}
